<main class="wealthlens-page">
  <header class="wealthlens-header">
    <div class="wealthlens-container header-inner">
      <a class="brand" href="https://www.bajajcapital.com" target="_blank" rel="noopener">
        <picture>
        <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
        <img src="assets/images/logo-bajaj-capital.png" alt="Bajaj Capital">
      </picture>
      </a>

      <nav class="desktop-nav" aria-label="Wealth sections">
        <a href="/wealth-report#how-it-works">How It Works</a>
        <a href="/wealth-report#included">What's Included</a>
      </nav>
    </div>
  </header>

  <section class="hero-section">
    <div class="wealthlens-container hero-grid">
      <div class="hero-copy">
        <p class="eyebrow gold">Bajaj Capital WealthLens Report</p>
        <div class="wealthlens-container-h1">
          <h1>Know your portfolio,</h1>
        </div>
        <h1>Beyond returns.</h1>
        <p class="hero-subtitle">Get a personalised analysis of your investments in under 60 seconds.</p>
        <button type="button" class="primary-cta cutom-primary-cta" #heroCta (click)="showLeadForm()">Get My WealthLens Report</button>
        <p class="microcopy">Powered by MF Central. Your data is never shared or sold.</p>
      </div>

      <div class="hero-visual" id="wealthlens-card">
        <div class="report-card">
          <div class="report-head">
            <h2>Your WealthLens Report</h2>
            <span>Ready in 60 sec</span>
          </div>

          <div class="score-area">
            <div class="score-ring" [class.animated]="scoreAnimated" aria-label="WealthLens score 7.2 out of 10">
              <div class="score-inner">
                <strong>{{ animatedScore }}</strong>
                <small>out of 10</small>
              </div>
            </div>
            <p>WealthLens Score</p>
          </div>

          <div class="pill-row">
            <span>Risk Assessment</span>
            <span>Portfolio Overlap</span>
            <span>Asset Allocation</span>
            <span>Gap Analysis</span>
          </div>
        </div>

        <div class="lead-card" *ngIf="isLeadFormVisible">
          <form #reviewForm="ngForm" (ngSubmit)="submitReviewForm(reviewForm)" *ngIf="!submitted  && !alreadySubmitted"  novalidate>
              <div class="form-grid">
              <div class="form-field">
                <label for="fullName">Full Name*</label>
                <input
                  id="fullName"
                  type="text"
                  name="fullName"
                  [(ngModel)]="name"
                  required
                  minlength="3"
                  maxlength="70"
                  pattern="^[A-Za-z ]+$"
                  #fullName="ngModel"
                  placeholder="Enter your name"
                  autocomplete="name"
                  (keypress)="onlyLetters($event)"
                  (paste)="onPasteName($event)">
                <div class="field-error" *ngIf="fullName.invalid && (fullName.touched || formSubmitted)">
                  <span *ngIf="fullName.errors?.['required']">Full name is required.</span>
                  <span *ngIf="fullName.errors?.['minlength']">Enter at least 3 characters.</span>
                  <span *ngIf="fullName.errors?.['pattern']">Only letters and spaces are allowed.</span>
                </div>
              </div>

              <div class="form-field">
                <label for="pan">PAN*</label>
                <input
                  id="pan"
                  type="text"
                  name="pan"
                  [(ngModel)]="pan"
                  required
                  minlength="10"
                  maxlength="10"
                  pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                  #panField="ngModel"
                  placeholder="Enter PAN"
                  autocomplete="off"
                  style="text-transform: uppercase"
                  (input)="convertPanToUppercase()">
                <div class="field-error" *ngIf="panField.invalid && (panField.touched || formSubmitted)">
                  <span *ngIf="panField.errors?.['required']">PAN is required.</span>
                  <span *ngIf="panField.errors?.['minlength'] || panField.errors?.['pattern']">Enter a valid PAN, for example ABCDE1234F.</span>
                </div>
              </div>

              <div class="form-field">
                <label for="mobile">Mobile Number*</label>
                <input
                  id="mobile"
                  type="tel"
                  name="mobile"
                  [(ngModel)]="mobile"
                  required
                  minlength="10"
                  maxlength="10"
                  pattern="^[6-9][0-9]{9}$"
                  #mobileField="ngModel"
                  placeholder="Enter 10-digit mobile"
                  autocomplete="tel"
                  inputmode="numeric"
                  (keypress)="onlyNumbers($event)"
                  (paste)="onPasteNumber($event)">
                <div class="field-error" *ngIf="mobileField.invalid && (mobileField.touched || formSubmitted)">
                  <span *ngIf="mobileField.errors?.['required']">Mobile number is required.</span>
                  <span *ngIf="mobileField.errors?.['minlength'] || mobileField.errors?.['pattern']">Enter a valid 10-digit mobile number starting with 6-9.</span>
                </div>
              </div>

              <div class="form-field">
                <label for="email">Email Address*</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  [(ngModel)]="email"
                  required
                  email
                  maxlength="80"
                  #emailField="ngModel"
                  placeholder="Enter your email"
                  autocomplete="email"
                  (keydown.space)="$event.preventDefault()">
                <div class="field-error" *ngIf="emailField.invalid && (emailField.touched || formSubmitted)">
                  <span *ngIf="emailField.errors?.['required']">Email address is required.</span>
                  <span *ngIf="emailField.errors?.['email']">Enter a valid email address.</span>
                </div>
              </div>

              <div class="form-field">
                <label for="reportType">Risk Profile*</label>
                <select
                  id="reportType"
                  name="reportType"
                  [(ngModel)]="reportType"
                  required
                  #reportTypeField="ngModel">
                  <option value="" disabled>Select risk profile</option>
                  <option *ngFor="let opt of reportTypeOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
                <div class="field-error" *ngIf="reportTypeField.invalid && (reportTypeField.touched || formSubmitted)">
                  <span *ngIf="reportTypeField.errors?.['required']">Risk profile is required.</span>
                </div>
              </div>
            </div>

            <!-- <button type="submit" class="schedule-btn" [disabled]="loadingSm">
              {{ loadingSm ? 'Please wait...' : 'Generate WealthLens Report' }}
            </button> -->
            <button type="submit" class="schedule-btn" [disabled]="reviewForm.invalid || loadingSm">
              {{ loadingSm ? 'Please wait...' : 'Generate WealthLens Report' }}
            </button>
          </form>
          <div class="form-success" *ngIf="alreadySubmitted">
            <div class="success-mark">✓</div>
            <h2>Your review request is scheduled.</h2>
            <p>Our advisor will connect with you shortly.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="metric-strip" aria-label="WealthLens highlights">
    <div class="wealthlens-container strip-grid">
      <p><strong>60+ yrs</strong> of financial expertise</p>
      <p><strong>MF Central</strong> verified integration</p>
      <p><strong>&lt;60 sec</strong> to your full report</p>
      <p><strong>100%</strong> secure &amp; confidential</p>
    </div>
  </section>

  <section class="steps-section" id="how-it-works">
    <div class="wealthlens-container">
      <p class="eyebrow red">How It Works</p>
      <h2>Three steps. Sixty seconds.</h2>
      <p class="section-subtitle">No uploads, no statements to dig up - just your PAN.</p>

      <div class="steps-line">
        <article class="step">
          <span>1</span>
          <h3>Enter your PAN</h3>
          <p>That's the only information we need to get started.</p>
        </article>
        <article class="step">
          <span>2</span>
          <h3>We fetch your MF holdings</h3>
          <p>Securely, via MF Central - across every fund house, not just ours.</p>
        </article>
        <article class="step">
          <span>3</span>
          <h3>Get your WealthLens Report</h3>
          <p>A complete, personalised analysis - ready in under 60 seconds.</p>
        </article>
      </div>
    </div>
  </section>

  <section class="included-section" id="included">
    <div class="wealthlens-container">
      <p class="eyebrow red">What's Included</p>
      <h2>Six things your MF statement never tells you.</h2>
      <p class="section-subtitle">Every WealthLens Report includes all six - no upsell, no partial version.</p>

      <div class="feature-grid">
        <article class="feature-card" *ngFor="let feature of features">
          <span class="feature-icon" [class]="'icon-' + feature.icon"></span>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description1 }}</p>
          <p>{{ feature.description2 }}</p>
        </article>
      </div>
    </div>
  </section>

  <section class="privacy-section">
    <div class="wealthlens-container">
      <p class="eyebrow red">Security &amp; Privacy</p>
      <h2>Your PAN. Your data.</h2>
      <h2>Your control.</h2>

      <div class="privacy-grid">
        <article class="privacy-card" *ngFor="let item of privacyItems">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- <section class="faq-section" id="faqs">
    <div class="faq-wrap">
      <p class="eyebrow red">FAQs</p>
      <h2>Common questions.</h2>

      <div class="faq-list">
        <article class="faq-item" *ngFor="let faq of faqs; let i = index" [class.open]="openFaqIndex === i">
          <button type="button" (click)="toggleFaq(i)" [attr.aria-expanded]="openFaqIndex === i">
            <span>{{ faq.question }}</span>
            <strong>+</strong>
          </button>
          <p *ngIf="openFaqIndex === i">{{ faq.answer }}</p>
        </article>
      </div>
    </div>
  </section> -->

  <section class="bottom-cta">
    <div class="wealthlens-container">
      <h2>Know your portfolio,</h2>
      <h2>beyond returns.</h2>
      <p>Get your personalised WealthLens Report in under 60 seconds.</p>
      <!-- <button type="button" class="primary-cta" (click)="showLeadForm()">Get My WealthLens Report</button> -->
      <button type="button" class="primary-cta cutom-primary-cta" #heroCta (click)="showLeadForm()">Get My WealthLens Report</button>
      <p class="microcopy">Powered by MF Central. Your data is never shared or sold.</p>
    </div>
  </section>

  <footer class="wealthlens-footer">
    <div class="wealthlens-container footer-inner">
      <p>© Bajaj Capital WealthLens Report</p>
      <p>Landing Page Concept</p>
    </div>
  </footer>

  <button type="button" class="mobile-sticky-cta" [class.visible]="showStickyBtn" (click)="showLeadForm()">
    Get My WealthLens Report
  </button>

  <!-- Modal Overlay for Lead Form (same-page flow like portfolio-review) -->
  <div class="wl-modal-overlay" *ngIf="isModalVisible" (click)="isOtpVisible ? null : (noDataFound ? closeNoDataPopup() : closeModal())">
    <div class="wl-modal-card" (click)="$event.stopPropagation()">
      <button class="wl-close-button" (click)="isOtpVisible ? closeOtpPopup() : (noDataFound ? closeNoDataPopup() : closeModal())">&times;</button>

      <!-- OTP Verification Screen -->
      <div *ngIf="isOtpVisible" class="wl-otp-screen">
        <h3 class="wl-modal-heading">Verify OTP</h3>
        <p class="wl-modal-subheading">Enter the 5-digit OTP sent to your registered mobile number to view your WealthLens Report.</p>

        <div class="wl-otp-inputs" (paste)="onOtpPaste($event)">
          <input
            *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIndex"
            #otpBox
            class="wl-otp-box"
            type="tel"
            inputmode="numeric"
            maxlength="1"
            autocomplete="one-time-code"
            [name]="'otpDigit' + i"
            [ngModel]="otpDigits[i]"
            [ngModelOptions]="{ standalone: true }"
            [attr.aria-label]="'OTP digit ' + (i + 1)"
            (input)="onOtpInput($event, i)"
            (keydown)="onOtpKeydown($event, i)">
        </div>

        <div class="wl-field-error wl-otp-error" *ngIf="otpError">{{ otpError }}</div>

        <div class="wl-otp-resend">
          <span *ngIf="!canResendOtp" class="wl-otp-timer">
            Resend OTP in {{ otpResendTimer }}s
          </span>
          <button
            *ngIf="canResendOtp"
            type="button"
            class="wl-otp-resend-btn"
            [disabled]="otpResending"
            (click)="resendOtp()">
            {{ otpResending ? 'Sending...' : 'Resend OTP' }}
          </button>
        </div>

        <button
          type="button"
          class="wl-submit-button"
          [disabled]="!isOtpComplete || otpVerifying"
          (click)="verifyOtp()">
          {{ otpVerifying ? 'Verifying...' : 'Verify' }}
        </button>
      </div>

      <!-- No Investment Data Screen -->
      <div *ngIf="!isOtpVisible && noDataFound" class="wl-nodata-screen">
        <div class="wl-nodata-icon">!</div>
        <h3 class="wl-modal-heading">No current investment found</h3>
        <p class="wl-modal-subheading">We couldn't find any mutual fund holdings linked to the details you entered. Please check your PAN and try again.</p>
        <button type="button" class="wl-submit-button wl-done-button" (click)="reloadForm()">OK</button>
      </div>

      <!-- Lead Form Screen -->
      <div *ngIf="!isOtpVisible && !noDataFound && !submitted && !alreadySubmitted" class="wl-lead-form-screen">
        <h3 class="wl-modal-heading">Get Your WealthLens Report</h3>
        <p class="wl-modal-subheading">Fill in your details below. Your personalised report will be ready in under 60 seconds.</p>

        <form #modalForm="ngForm" (ngSubmit)="submitModalForm(modalForm)" novalidate>
          <div class="wl-modal-form-grid">
            <div class="wl-form-group">
              <label for="modalFullName">Full Name<span class="wl-required">*</span></label>
              <input
                id="modalFullName"
                type="text"
                name="modalFullName"
                [(ngModel)]="name"
                required
                minlength="3"
                maxlength="70"
                pattern="^[A-Za-z ]+$"
                #modalFullName="ngModel"
                placeholder="Enter your name"
                autocomplete="name"
                (keypress)="onlyLetters($event)"
                (paste)="onPasteName($event)">
              <div class="wl-field-error" *ngIf="modalFullName.invalid && (modalFullName.touched || formSubmitted)">
                <span *ngIf="modalFullName.errors?.['required']">Full name is required.</span>
                <span *ngIf="modalFullName.errors?.['minlength']">Enter at least 3 characters.</span>
                <span *ngIf="modalFullName.errors?.['pattern']">Only letters and spaces are allowed.</span>
              </div>
            </div>

            <div class="wl-form-group">
              <label for="modalPan">PAN<span class="wl-required">*</span></label>
              <input
                id="modalPan"
                type="text"
                name="modalPan"
                [(ngModel)]="pan"
                required
                minlength="10"
                maxlength="10"
                pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                #modalPanField="ngModel"
                placeholder="Enter PAN"
                autocomplete="off"
                style="text-transform: uppercase"
                (input)="convertPanToUppercase()">
              <div class="wl-field-error" *ngIf="modalPanField.invalid && (modalPanField.touched || formSubmitted)">
                <span *ngIf="modalPanField.errors?.['required']">PAN is required.</span>
                <span *ngIf="modalPanField.errors?.['minlength'] || modalPanField.errors?.['pattern']">Enter a valid PAN, for example ABCDE1234F.</span>
              </div>
            </div>

            <div class="wl-form-group">
              <label for="modalMobile">Mobile Number<span class="wl-required">*</span></label>
              <input
                id="modalMobile"
                type="tel"
                name="modalMobile"
                [(ngModel)]="mobile"
                required
                minlength="10"
                maxlength="10"
                pattern="^[6-9][0-9]{9}$"
                #modalMobileField="ngModel"
                placeholder="Enter 10-digit mobile"
                autocomplete="tel"
                inputmode="numeric"
                (keypress)="onlyNumbers($event)"
                (paste)="onPasteNumber($event)">
              <div class="wl-field-error" *ngIf="modalMobileField.invalid && (modalMobileField.touched || formSubmitted)">
                <span *ngIf="modalMobileField.errors?.['required']">Mobile number is required.</span>
                <span *ngIf="modalMobileField.errors?.['minlength'] || modalMobileField.errors?.['pattern']">Enter a valid 10-digit mobile number starting with 6-9.</span>
              </div>
            </div>

            <div class="wl-form-group">
              <label for="modalEmail">Email Address<span class="wl-required">*</span></label>
              <input
                id="modalEmail"
                type="email"
                name="modalEmail"
                [(ngModel)]="email"
                required
                email
                maxlength="80"
                #modalEmailField="ngModel"
                placeholder="Enter your email"
                autocomplete="email"
                (keydown.space)="$event.preventDefault()">
              <div class="wl-field-error" *ngIf="modalEmailField.invalid && (modalEmailField.touched || formSubmitted)">
                <span *ngIf="modalEmailField.errors?.['required']">Email address is required.</span>
                <span *ngIf="modalEmailField.errors?.['email']">Enter a valid email address.</span>
              </div>
            </div>

            <div class="wl-form-group">
              <label for="modalPincode">Pincode<span class="wl-required">*</span></label>
              <input
                id="modalPincode"
                type="tel"
                name="modalPincode"
                [(ngModel)]="pincode"
                required
                minlength="6"
                maxlength="6"
                pattern="^[1-9][0-9]{5}$"
                #modalPincodeField="ngModel"
                placeholder="Enter 6-digit pincode"
                autocomplete="postal-code"
                inputmode="numeric"
                (keypress)="onlyNumbers($event)"
                (paste)="onPasteNumber($event)">
              <div class="wl-field-error" *ngIf="modalPincodeField.invalid && (modalPincodeField.touched || formSubmitted)">
                <span *ngIf="modalPincodeField.errors?.['required']">Pincode is required.</span>
                <span *ngIf="modalPincodeField.errors?.['minlength'] || modalPincodeField.errors?.['pattern']">Enter a valid 6-digit pincode.</span>
              </div>
            </div>

            <div class="wl-form-group">
              <label for="modalReportType">Risk Profile<span class="wl-required">*</span></label>
              <select
                id="modalReportType"
                name="modalReportType"
                [(ngModel)]="reportType"
                required
                #modalReportTypeField="ngModel">
                <option value="" disabled>Select risk profile</option>
                <option *ngFor="let opt of reportTypeOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
              <div class="wl-field-error" *ngIf="modalReportTypeField.invalid && (modalReportTypeField.touched || formSubmitted)">
                <span *ngIf="modalReportTypeField.errors?.['required']">Risk profile is required.</span>
              </div>
            </div>
          </div>

          <button type="submit" class="wl-submit-button" [disabled]="modalForm.invalid || loadingSm">
            {{ loadingSm ? 'Please wait...' : 'Generate WealthLens Report' }}
          </button>
        </form>
      </div>

      <!-- Success Screen -->
      <div *ngIf="!isOtpVisible && !noDataFound && (submitted || alreadySubmitted)" class="wl-success-screen">
        <div class="wl-success-icon">&#10004;</div>
        <h3 class="wl-modal-heading">{{ alreadySubmitted ? 'Already Submitted' : 'Thank You!' }}</h3>
        <p class="wl-modal-subheading">{{ successMessage || 'Your WealthLens Report is being generated. Our advisor will connect shortly.' }}</p>
        <button class="wl-submit-button wl-done-button" (click)="closeModal()">Done</button>
      </div>

    </div>
  </div>
</main>
